import React from 'react';
import { Svg, Path } from 'react-native-svg';

interface ClockDashIconProps {
  color?: string;
  size?: number;
}

const ClockDashIcon: React.FC<ClockDashIconProps> = ({ color = '#DE5609', size = 16 }) => (
  <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <Path d="M9.82627 9.27716L7.96094 8.1629V5.75537" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M3.18555 4.42266C3.46573 4.04066 3.79067 3.69431 4.15322 3.38818" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M11.7082 12.7241C10.804 13.4331 9.68783 13.8909 8.45616 13.9831C7.84976 14.0285 7.25763 13.9805 6.69336 13.854" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M4.56763 12.9074C3.66351 12.2822 2.94034 11.4118 2.48828 10.3857" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M2.21907 6.36475C2.04395 7.00683 1.96807 7.68589 2.01996 8.38703" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M13.095 11.1488C13.7014 10.1701 14.0393 9.0124 13.992 7.77553C13.8642 4.46066 11.0747 1.87737 7.75977 2.0045" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default ClockDashIcon;
